/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useState } from "react";
import { DoughnutChart, Indicator } from "../../components/Charts";
import "./Dashboard.css";
import moment from "moment/moment";
import dayjs from "dayjs";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import { BACKEND_URL, env } from "../../config/config";
import Loader from "../../components/Loader/Loader";
import axios from "axios";
import Modal from "../../components/Modal/Modal";
import { OpenDocumentList } from "../../components/Dashboard";
import { currencyFormatter } from "../../helpers/currencyHelper";
import OpenContentApprove from "../../components/Proposal/OpenContentApprove/OpenContentApprove";
import { OpenModalProposal } from "../../components/Proposal/OpenModalProposal/OpenModalProposal";
import { useAuth } from "../../hooks";
import { OpenModalInvoice } from "../../components/Invoices";
import MaterialTable, { MTableToolbar } from "@material-table/core";
import { ExportPdf, ExportCsv } from "@material-table/exporters";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FileOpenOutlinedIcon from "@mui/icons-material/FileOpenOutlined";
import { esES } from "@mui/material/locale";
import { Button, Select, DatePicker, Space, message } from "antd";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { OpenModalAccount } from "../../components/Account";
import {
  URL_INTERACTIVE_CALCULATOR,
  URL_INTERACTIVE_CALCULATOR_TEST,
} from "../../config/constants";
import { useTheme as useAppTheme } from "../../context/ThemeContext";
import { CreditCardOutlined } from "@mui/icons-material";
import {
  Alert as MUIAlert,
  AlertTitle,
  Box,
  Divider,
  Grid,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const { RangePicker } = DatePicker;

export function Dashboard() {
  const [isLoading, setIsLoading] = useState(true);
  const [indicators, setIndicators] = useState([]);
  const [parcAgreementDataSet, setParcAgreementDataSet] = useState([]);
  const [proposalsByStatusDataSet, setProposalsByStatusDataSet] = useState([]);
  const [invoicesByStatusDataSet, setInvoicesByStatusDataSet] = useState([]);
  const [openProposalsData, setOpenProposalsDataset] = useState([]);
  const [openInvoicesData, setOpenInvoicesDataset] = useState([]);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");

  const [modalContent, setModalContent] = useState(null);
  const [reload, setReload] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [paying, setPaying] = useState(false);

  // Filters
  const [proposalStatusFilter, setProposalStatusFilter] = useState(undefined);
  const [proposalDateFilter, setProposalDateFilter] = useState(undefined);
  const [invoiceDateFilter, setInvoiceDateFilter] = useState(undefined);
  const [dateFilter, setDateFilter] = useState(undefined); // etiqueta del quick filter
  const [proposalDateRange, setProposalDateRange] = useState(null);
  const [invoiceStatusFilter, setInvoiceStatusFilter] = useState(undefined);
  const [invoiceDateRange, setInvoiceDateRange] = useState(null); // [dayjs|null, dayjs|null]

  const { user } = useAuth();
  const { themeMode } = useAppTheme();
  const isDarkMode = themeMode === "dark";
  dayjs.extend(quarterOfYear);
  useEffect(() => {
    if (user) {
      getDataDashboard(user);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, reload]);

  const getDataDashboard = async (usuario) => {
    setIsLoading(true);

    if (usuario?._id) {
      console.log("ID USUARIO ,", usuario._id);
      const url = `${BACKEND_URL}/customers/getDashboard?id=` + usuario._id;

      const dataDashboard = await axios
        .get(url)
        .catch((err) => console.log(err));

      if (dataDashboard?.data) {
        console.log("dashboard data ----->", dataDashboard?.data);
        const payload = dataDashboard?.data?.data;

        setIndicators(payload?.indicators);
        setOpenProposalsDataset(payload?.openProposals || []);
        setOpenInvoicesDataset(payload?.openInvoices || []);

        const parcData = getParcData(payload);
        setParcAgreementDataSet(parcData);

        const proposalsByStatusData = getProposalsByStatusData(payload);
        setProposalsByStatusDataSet(proposalsByStatusData);

        const invoicesByStatusData = getInovoicesByStatusData(payload);
        setInvoicesByStatusDataSet(invoicesByStatusData);

        setIsLoading(false);
      } else {
        setIsLoading(false);
        console.log("No dashboard data retrieved");
      }
    }
  };

  // =========================
  // Helpers (status labels)
  // =========================
  function getProposalStatusLabel(row) {
    return (
      row?.status?.displayName ||
      row?.status?.description ||
      row?.status?._id ||
      "-"
    );
  }

  const dateOptions = useMemo(() => {
    const map = new Map();
    map.set("THISMONTH", "This Month");
    map.set("LASTMONTH", "Last Month");
    map.set("THISQUARTER", "This Quarter");
    map.set("LASTQUARTER", "Last Quarter");
    map.set("THISYEAR", "This Year");
    map.set("LASTYEAR", "Last Year");
    return Array.from(map.entries()).map(([value, label]) => ({
      value,
      label,
    }));
  }, []);

  function getInvoiceStatusLabel(row) {
    if (row?.invoiceStatus && typeof row.invoiceStatus === "object") {
      return row.invoiceStatus?.name || row.invoiceStatus?._id || "-";
    }
    if (typeof row?.invoiceStatus === "string") {
      return row.invoiceStatus;
    }
    return "-";
  }

  // =========================
  // Export helpers (shared)
  // =========================
  const getCompanyName = (row) =>
    (row?.account?.accountName || row?.lead?.companyName || "").toString();

  const fmtDate = (d) => (d ? moment(d).format("MM/DD/YYYY") : "-");
  const fmtMoney = (n) => currencyFormatter(Number(n ?? 0));
  const getProposalNumberFromInvoice = (row) =>
    row?.opportunity?._id ?? row?.opportunity ?? "";

  // =========================
  // Options de filtros
  // =========================
  const proposalStatusOptions = useMemo(() => {
    const set = new Set();
    (openProposalsData || []).forEach((row) => {
      const label = getProposalStatusLabel(row);
      if (label && label !== "-") set.add(String(label));
    });
    return Array.from(set).map((label) => ({ value: label, label }));
  }, [openProposalsData]);

  const invoiceStatusOptions = useMemo(() => {
    const set = new Set();
    (openInvoicesData || []).forEach((row) => {
      const label = getInvoiceStatusLabel(row);
      if (label && label !== "-") set.add(String(label));
    });
    return Array.from(set).map((label) => ({ value: label, label }));
  }, [openInvoicesData]);

  // =========================
  // Handlers date range (dayjs)
  // =========================
  const handleProposalDateRangeChange = (vals) => {
    if (!vals || vals.length === 0) return setProposalDateRange(null);
    const [from, to] = vals;
    setProposalDateRange([from ? dayjs(from) : null, to ? dayjs(to) : null]);
  };

  const handleInvoiceDateRangeChange = (vals) => {
    if (!vals || vals.length === 0) return setInvoiceDateRange(null);
    const [from, to] = vals;
    setInvoiceDateRange([from ? dayjs(from) : null, to ? dayjs(to) : null]);
  };

  // =========================
  // Data filtrada (dayjs)
  // =========================
  const filteredOpenProposalsData = useMemo(() => {
    const [from, to] = proposalDateRange || [null, null];

    return (openProposalsData || []).filter((row) => {
      if (proposalStatusFilter) {
        if (getProposalStatusLabel(row) !== proposalStatusFilter) return false;
      }
      if (from || to) {
        const reqDate = row?.requestedDate ? dayjs(row.requestedDate) : null;
        if (!reqDate || !reqDate.isValid()) return false;
        if (from && reqDate.isBefore(from.startOf("day"))) return false;
        if (to && reqDate.isAfter(to.endOf("day"))) return false;
      }
      return true;
    });
  }, [openProposalsData, proposalStatusFilter, proposalDateRange]);

  const filteredOpenInvoicesData = useMemo(() => {
    const [from, to] = invoiceDateRange || [null, null];
    return (openInvoicesData || []).filter((row) => {
      if (
        invoiceStatusFilter &&
        getInvoiceStatusLabel(row) !== invoiceStatusFilter
      )
        return false;

      if (from || to) {
        const svcDate = row?.dateService ? dayjs(row.dateService) : null;
        if (!svcDate?.isValid()) return false;
        if (from && svcDate.isBefore(from.startOf("day"))) return false;
        if (to && svcDate.isAfter(to.endOf("day"))) return false;
      }
      return true;
    });
  }, [openInvoicesData, invoiceStatusFilter, invoiceDateRange]);

  // =========================
  // Columnas (UI)
  // =========================
  const openProposalscolumns = [
    {
      title: "Name",
      field: "opportunityName",
      render: (rowData) => (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <span>{rowData.opportunityName}</span>
          <span>
            {rowData.approvedByCustomer ? (
              <CheckCircleOutlineIcon
                style={{ paddingLeft: "5px", color: "#008f39" }}
              />
            ) : (
              ""
            )}
          </span>
        </div>
      ),
    },
    {
      title: "Requested Date",
      field: "requestedDate",
      render: (rowData) => (
        <span>
          {rowData?.requestedDate
            ? moment(rowData.requestedDate).format("MM/DD/YYYY")
            : "-"}
        </span>
      ),
    },
    {
      title: "Valid Until",
      field: "validUntil",
      render: (rowData) => (
        <span>
          {rowData?.validUntil
            ? moment(rowData.validUntil).format("MM/DD/YYYY")
            : "-"}
        </span>
      ),
    },
    { title: "Quotes", field: "quoteCount" },
    { title: "TR's", field: "numberTRs" },
    {
      title: "Amount",
      field: "amount",
      render: (rowData) => <span>{currencyFormatter(rowData?.amount)}</span>,
    },
    {
      title: "Status",
      field: "status.displayName",
      render: (rowData) => (
        <span className="table-status-pill">
          {getProposalStatusLabel(rowData)}
        </span>
      ),
    },
  ];

  // estilos centrados para la tabla de invoices
  const centerHeader = { whiteSpace: "normal", textAlign: "center" };
  const centerCell = { whiteSpace: "normal", textAlign: "center" };

  const openInvoicescolumns = [
    {
      title: "Site",
      field: "account.accountName",
      headerStyle: centerHeader,
      cellStyle: {
        ...centerCell,
        maxWidth: 320,
        textOverflow: "ellipsis",
        overflow: "hidden",
      },
      render: (rowData) => (
        <span onClick={() => handleColumnClick(rowData)} className="rowClick">
          {rowData?.account?.accountName || rowData?.lead?.companyName}
        </span>
      ),
    },
    {
      title: "Invoice Number",
      field: "invoiceNo",
      headerStyle: centerHeader,
      cellStyle: centerCell,
    },
    {
      title: "Date of Service",
      field: "dateService",
      headerStyle: centerHeader,
      cellStyle: centerCell,
      customSort: (a, b) =>
        (a?.dateService ? new Date(a.dateService).getTime() : 0) -
        (b?.dateService ? new Date(b.dateService).getTime() : 0),
      render: (rowData) => (
        <span>
          {rowData?.dateService
            ? moment(rowData.dateService).format("MM/DD/YYYY")
            : "-"}
        </span>
      ),
    },
    {
      title: "Dispatch Number",
      field: "dispatch",
      headerStyle: centerHeader,
      cellStyle: centerCell,
    },
    {
      title: "Proposal Number",
      field: "opportunity",
      headerStyle: centerHeader,
      cellStyle: centerCell,
      render: (rowData) => (
        <span
          onClick={() => onViewProposalDetail(rowData)}
          className="rowClick"
        >
          {rowData?.opportunity?._id ?? rowData?.opportunity ?? "-"}
        </span>
      ),
    },
    {
      title: "Invoice Date",
      field: "invoiceDate",
      headerStyle: centerHeader,
      cellStyle: centerCell,
      customSort: (a, b) =>
        (a?.invoiceDate ? new Date(a.invoiceDate).getTime() : 0) -
        (b?.invoiceDate ? new Date(b.invoiceDate).getTime() : 0),
      render: (rowData) => (
        <span>
          {rowData?.invoiceDate
            ? moment(rowData.invoiceDate).format("MM/DD/YYYY")
            : "-"}
        </span>
      ),
    },
    {
      title: "Amount",
      field: "totalAmountDue", // sort por el dato real
      headerStyle: { ...centerHeader, fontVariantNumeric: "tabular-nums" },
      cellStyle: { ...centerCell, fontVariantNumeric: "tabular-nums" },
      customSort: (a, b) =>
        (Number(a?.totalAmountDue) || 0) - (Number(b?.totalAmountDue) || 0),
      render: (r) => <span>{fmtMoney(r?.totalAmountDue)}</span>,
    },
    {
      title: "Status",
      field: "invoiceStatus.name",
      headerStyle: centerHeader,
      cellStyle: centerCell,
      render: (rowData) => (
        <span className="table-status-pill">
          {getInvoiceStatusLabel(rowData)}
        </span>
      ),
    },
  ];

  // =========================
  // Export builders (TODAS las filas filtradas)
  // =========================
  const proposalExportColumns = [
    { title: "Company", field: "company" },
    { title: "Proposal number", field: "proposalNo" },
    { title: "Proposal name", field: "opportunityName" },
    { title: "Requested Date", field: "requestedDate" },
    { title: "Valid Until", field: "validUntil" },
    { title: "Quotes", field: "quoteCount" },
    { title: "TR's", field: "numberTRs" },
    { title: "Amount", field: "amount" },
    { title: "Status", field: "status" },
  ];

  const buildProposalExportRows = (rows) =>
    (rows || []).map((r) => ({
      company: getCompanyName(r),
      proposalNo: r?.proposalNo ?? "",
      opportunityName: r?.opportunityName ?? "",
      requestedDate: fmtDate(r?.requestedDate),
      validUntil: fmtDate(r?.validUntil),
      quoteCount: r?.quoteCount ?? 0,
      numberTRs: r?.numberTRs ?? 0,
      amount: fmtMoney(r?.amount),
      status: getProposalStatusLabel(r),
    }));

  const invoiceExportColumns = [
    { title: "Site", field: "site" },
    { title: "Invoice Number", field: "invoiceNo" },
    { title: "Date of Service", field: "dateService" },
    { title: "Dispatch Number", field: "dispatch" },
    { title: "Proposal Number", field: "proposalNumber" },
    { title: "Invoice Date", field: "invoiceDate" },
    { title: "Status", field: "status" },
    { title: "Amount", field: "amount" },
  ];

  const buildInvoiceExportRows = (rows) =>
    (rows || []).map((r) => ({
      site: getCompanyName(r),
      invoiceNo: r?.invoiceNo ?? "",
      dateService: fmtDate(r?.dateService),
      dispatch: r?.dispatch ?? "",
      proposalNumber: getProposalNumberFromInvoice(r),
      invoiceDate: fmtDate(r?.invoiceDate),
      status: getInvoiceStatusLabel(r),
      amount: fmtMoney(r?.totalAmountDue),
    }));

  // =========================
  // Varias funciones existentes
  // =========================
  const onViewDetail = (data) => {
    setIsVisibleModal(true);
    setModalTitle("Account information");
    setModalContent(<OpenModalAccount data={data} />);
  };

  const onViewProposalDetail = (data) => {
    setIsVisibleModal(true);
    setModalTitle(
      `Proposal detail # ${data.opportunity._id ? data.opportunity._id : data}`,
    );
    setModalContent(
      <OpenModalProposal proposal={data.opportunity} preview={true} />,
    );
  };

  const handleColumnClick = (rowData) => {
    onViewDetail(rowData?.account || rowData.lead);
  };

  const openInteractiveReport = async (rowData) => {
    const mode = env;
    if (mode === "testing") {
      window.open(
        `${URL_INTERACTIVE_CALCULATOR_TEST}/${rowData.proposalNo}?portal=true&userID=${user._id}&userEmail=${user.email.main}`,
        "_blank",
      );
    } else {
      window.open(
        `${URL_INTERACTIVE_CALCULATOR}/${rowData.proposalNo}?portal=true&userID=${user._id}&userEmail=${user.email.main}`,
        "_blank",
      );
    }
  };

  const showProposalDocumentsList = async (data) => {
    const url = `${BACKEND_URL}/documentmasters/getByOpportunityId/` + data._id;
    const opportunityDocuments = await axios
      .get(url)
      .catch((err) => console.log(err));

    const dataElement = [];
    if (opportunityDocuments && opportunityDocuments.data.length > 0) {
      opportunityDocuments.data.forEach((document) => {
        dataElement.push({
          documentName: document?.documentName,
          documentType: document?.documentType?.name,
          uploadedDate: moment(document?.created).format("MM/DD/YYYY"),
          documentPath: document?.documentPath,
        });
      });
      setIsVisibleModal(true);
      setModalTitle("Proposal Documents");
      setModalContent(
        <div style={{ width: "100%" }}>
          <OpenDocumentList data={dataElement} title="" />
        </div>,
      );
    } else {
      setIsVisibleModal(true);
      setModalTitle("Proposal Documents");
      setModalContent(
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <span style={{ fontWeight: "bold" }}>No documents</span>
        </div>,
      );
    }
  };
  const handleInvoiceDateFilter = (val) => {
    let from = null,
      to = null;

    switch (val) {
      case "THISMONTH":
        from = dayjs().startOf("month");
        to = dayjs().endOf("month");
        break;
      case "LASTMONTH":
        from = dayjs().subtract(1, "month").startOf("month");
        to = dayjs().subtract(1, "month").endOf("month");
        break;
      case "THISQUARTER":
        from = dayjs().startOf("quarter");
        to = dayjs().endOf("quarter");
        break;
      case "LASTQUARTER":
        from = dayjs().subtract(1, "quarter").startOf("quarter");
        to = dayjs().subtract(1, "quarter").endOf("quarter");
        break;
      case "THISYEAR":
        from = dayjs().startOf("year");
        to = dayjs().endOf("year");
        break;
      case "LASTYEAR":
        from = dayjs().subtract(1, "year").startOf("year");
        to = dayjs().subtract(1, "year").endOf("year");
        break;
      default:
        setInvoiceDateRange(null);
        setDateFilter(undefined);
        return;
    }

    setInvoiceDateRange([from, to]);
    setInvoiceDateFilter(val);
  };

  const handleProposalDateFilter = (val) => {
    let from = null,
      to = null;

    switch (val) {
      case "THISMONTH":
        from = dayjs().startOf("month");
        to = dayjs().endOf("month");
        break;
      case "LASTMONTH":
        from = dayjs().subtract(1, "month").startOf("month");
        to = dayjs().subtract(1, "month").endOf("month");
        break;
      case "THISQUARTER":
        from = dayjs().startOf("quarter");
        to = dayjs().endOf("quarter");
        break;
      case "LASTQUARTER":
        from = dayjs().subtract(1, "quarter").startOf("quarter");
        to = dayjs().subtract(1, "quarter").endOf("quarter");
        break;
      case "THISYEAR":
        from = dayjs().startOf("year");
        to = dayjs().endOf("year");
        break;
      case "LASTYEAR":
        from = dayjs().subtract(1, "year").startOf("year");
        to = dayjs().subtract(1, "year").endOf("year");
        break;
      default:
        setProposalDateRange(null);
        setDateFilter(undefined);
        return;
    }

    setProposalDateRange([from, to]);
    setProposalDateFilter(val);
  };

  const showInvoiceDocumentsList = async (data) => {
    const url =
      `${BACKEND_URL}/documentmasters/getByOpportunityId/` +
      data.opportunity._id;
    const opportunityDocuments = await axios
      .get(url)
      .catch((err) => console.log(err));

    const dataElement = [];
    if (opportunityDocuments && opportunityDocuments.data.length > 0) {
      opportunityDocuments.data.forEach((document) => {
        dataElement.push({
          documentName: document?.documentName,
          documentType: document?.documentType?.name,
          uploadedDate: moment(document?.created).format("MM/DD/YYYY"),
          documentPath: document?.documentPath,
        });
      });
      setIsVisibleModal(true);
      setModalTitle("Proposal Documents");
      setModalContent(
        <div style={{ width: "100%" }}>
          <OpenDocumentList data={dataElement} title="" />
        </div>,
      );
    } else {
      setIsVisibleModal(true);
      setModalTitle("Invoice Documents");
      setModalContent(
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <span style={{ fontWeight: "bold" }}>No documents</span>
        </div>,
      );
    }
  };

  const pay = async (rowData) => {
    const { data } = await axios
      .get(`${BACKEND_URL}/processPayment?ref=${rowData._id}`)
      .catch((err) => console.log(err));
    const paymentURL = data?.url;
    window.open(
      paymentURL,
      "_blank",
      "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=600,height=800",
    );
  };

  const onAskPay = (rowData) => {
    const amount = Number(rowData?.totalAmountDue || 0);
    const discountRate = 0.03;
    const fee = amount * discountRate;
    const totalWithDiscount = amount + fee;

    setModalTitle("Confirm payment");
    setModalContent(
      <Box sx={{ width: "100%", maxWidth: 560, px: 2, py: 1, mx: "auto" }}>
        <MUIAlert
          severity="info"
          icon={<InfoOutlinedIcon fontSize="small" />}
          sx={{ mb: 1.5 }}
        >
          <AlertTitle sx={{ fontWeight: 600, mb: 0.5 }}>Heads up</AlertTitle>
          A 3% fee will be applied at checkout.
          <br />
          You will be redirected to our secure payment page to complete the
          transaction.
        </MUIAlert>

        <Divider sx={{ my: 1.5 }} />

        <Box sx={{ mb: 1 }}>
          <Grid container rowSpacing={0.5} columnSpacing={2}>
            <Grid item xs={6} sx={{ color: "text.secondary" }}>
              Invoice
            </Grid>
            <Grid item xs={6} sx={{ textAlign: "right", fontWeight: 600 }}>
              #{rowData?.invoiceNo}
            </Grid>

            <Grid item xs={6} sx={{ color: "text.secondary" }}>
              Date
            </Grid>
            <Grid item xs={6} sx={{ textAlign: "right" }}>
              {moment(rowData?.invoiceDate).format("MM/DD/YYYY")}
            </Grid>

            <Grid item xs={6} sx={{ color: "text.secondary" }}>
              Site
            </Grid>
            <Grid item xs={6} sx={{ textAlign: "right" }}>
              {rowData?.account?.accountName || rowData?.lead?.companyName}
            </Grid>
          </Grid>
        </Box>

        <Divider sx={{ my: 1.5 }} />

        <Box>
          <Grid container rowSpacing={0.5} columnSpacing={2}>
            <Grid item xs={6} sx={{ color: "text.secondary" }}>
              Amount
            </Grid>
            <Grid item xs={6} sx={{ textAlign: "right" }}>
              {currencyFormatter(amount)}
            </Grid>

            <Grid item xs={6} sx={{ color: "text.secondary" }}>
              Fee (3%)
            </Grid>
            <Grid item xs={6} sx={{ textAlign: "right" }}>
              +{currencyFormatter(fee)}
            </Grid>

            <Grid item xs={6} sx={{ fontWeight: 600 }}>
              Total to pay
            </Grid>
            <Grid item xs={6} sx={{ textAlign: "right", fontWeight: 600 }}>
              {currencyFormatter(totalWithDiscount)}
            </Grid>
          </Grid>
        </Box>

        <Box
          sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 2 }}
        >
          <Button onClick={() => setIsVisibleModal(false)}>Cancel</Button>
          <Button
            type="primary"
            icon={<CreditCardOutlined />}
            loading={paying}
            onClick={() => handleProceedPay(rowData)}
          >
            Confirm & pay
          </Button>
        </Box>
      </Box>,
    );

    setIsVisibleModal(true);
  };

  const handleProceedPay = async (rowData) => {
    try {
      setPaying(true);
      await pay(rowData);
      setIsVisibleModal(false);
    } finally {
      setPaying(false);
    }
  };

  const colors = [
    "#2563EB",
    "#0EA5A3",
    "#16A34A",
    "#7C3AED",
    "#EF4444",
    "#F97316",
  ];

  const tableToolbarStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 16,
    padding: "14px 20px",
    borderBottom: "1px solid var(--border)",
    backgroundColor: "var(--table-header-bg)",
  };

  const theme = useMemo(
    () =>
      createTheme(
        {
          palette: {
            mode: isDarkMode ? "dark" : "light",
            primary: { main: "#E16726" },
            background: {
              default: isDarkMode ? "#0a0c0f" : "#f4f5f7",
              paper: isDarkMode ? "#13151a" : "#ffffff",
            },
            text: {
              primary: isDarkMode ? "#f3f4f6" : "#1a1d23",
              secondary: isDarkMode ? "#9ca3af" : "#6b7280",
            },
          },
          typography: {
            fontFamily:
              "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            fontSize: 13,
          },
          components: {
            MuiTableCell: {
              styleOverrides: {
                head: {
                  backgroundColor: isDarkMode ? "#161820" : "#fafafa",
                  fontWeight: 600,
                  color: isDarkMode ? "#f3f4f6" : "#1a1d23",
                  borderBottom: `2px solid ${isDarkMode ? "#2a2d36" : "#e8eaed"}`,
                  padding: "16px 20px",
                },
                root: {
                  padding: "14px 20px",
                  borderColor: isDarkMode ? "#2a2d36" : "#e8eaed",
                  color: isDarkMode ? "#f3f4f6" : "#1a1d23",
                },
              },
            },
            MuiPaper: {
              styleOverrides: {
                root: {
                  backgroundImage: "none",
                  boxShadow: "none !important",
                  borderRadius: "0px !important",
                  border: "none !important",
                },
              },
            },
          },
        },
        esES,
      ),
    [isDarkMode],
  );

  if (user === null || user === undefined) {
    return <Loader />;
  }

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <div className="indicators-container">
        {indicators?.map((i, index) => (
          <Indicator
            key={index}
            value={i?.value}
            title={i?.key}
            color={colors[index % colors.length]}
          />
        ))}
      </div>

      <div className="charts-container">
        {parcAgreementDataSet.length <= 0 ? (
          <span>No data found</span>
        ) : (
          <>
            <DoughnutChart
              title={"Proposals (By Status)"}
              dataSet={proposalsByStatusDataSet}
              setIsVisibleModal={setIsVisibleModal}
              setModalTitle={setModalTitle}
              setModalContent={setModalContent}
            />

            <DoughnutChart
              title={"Invoices (By Status)"}
              dataSet={invoicesByStatusDataSet}
              setIsVisibleModal={setIsVisibleModal}
              setModalTitle={setModalTitle}
              setModalContent={setModalContent}
            />
            <DoughnutChart
              title="PARC Agreement"
              dataSet={parcAgreementDataSet}
              setIsVisibleModal={setIsVisibleModal}
              setModalTitle={setModalTitle}
              setModalContent={setModalContent}
            />
          </>
        )}
      </div>

      {/* ================= Open Proposals ================= */}
      <div className="dashboard-table-container">
        <ThemeProvider theme={theme}>
          <MaterialTable
            isLoading={loadingTable}
            columns={openProposalscolumns}
            className="genericTable"
            components={{
              Toolbar: (props) => (
                <div style={tableToolbarStyle}>
                  <div style={{ flex: "1 1 300px" }}>
                    <MTableToolbar {...props} />
                  </div>
                  <Space wrap align="center" size={12}>
                    <Select
                      allowClear
                      placeholder="Quick Filter"
                      className="filter-select"
                      value={dateFilter}
                      onChange={handleProposalDateFilter}
                      options={dateOptions}
                    />
                    <Select
                      allowClear
                      placeholder="Filter by Status"
                      className="filter-select"
                      value={proposalStatusFilter}
                      onChange={(v) => setProposalStatusFilter(v)}
                      options={proposalStatusOptions}
                    />
                    <RangePicker
                      value={proposalDateRange || undefined}
                      onChange={handleProposalDateRangeChange}
                      format="MM/DD/YYYY"
                      className="filter-range-picker"
                      placeholder={["From (Requested)", "To (Requested)"]}
                      allowClear
                    />
                    <Button
                      className="filter-clear-btn"
                      onClick={() => {
                        setProposalStatusFilter(undefined);
                        setProposalDateRange(null);
                        setDateFilter(undefined);
                      }}
                    >
                      Clear
                    </Button>
                  </Space>
                </div>
              ),
            }}
            data={filteredOpenProposalsData}
            actions={[
              (rowData) => ({
                icon: () => (
                  <ArticleOutlinedIcon className="table-action-icon table-action-icon--view" />
                ),
                tooltip: "Open Interactive Report",
                onClick: () => openInteractiveReport(rowData),
                disabled:
                  rowData.approvedByCustomer === true ||
                  rowData.status._id !== "PROPOSAL" ||
                  rowData.amount <= 0,
                hidden:
                  rowData.approvedByCustomer === true ||
                  rowData.status._id !== "PROPOSAL" ||
                  rowData.amount <= 0,
              }),
              (rowData) => ({
                icon: () => (
                  <FileOpenOutlinedIcon className="table-action-icon table-action-icon--documents" />
                ),
                tooltip: "Open Documents",
                onClick: (event, rowData) => {
                  showProposalDocumentsList(rowData);
                },
              }),
            ]}
            options={{
              actionsColumnIndex: -1,
              pageSize: 5,
              filtering: false,
              exportMenu: [
                {
                  label: "Export to PDF",
                  exportFunc: () => {
                    const rows = buildProposalExportRows(
                      filteredOpenProposalsData,
                    );
                    ExportPdf(
                      proposalExportColumns,
                      rows,
                      "Proposal Report - " + new Date().toISOString(),
                    );
                  },
                },
                {
                  label: "Export to CSV",
                  exportFunc: () => {
                    const rows = buildProposalExportRows(
                      filteredOpenProposalsData,
                    );
                    ExportCsv(
                      proposalExportColumns,
                      rows,
                      "Proposal Report - " + new Date().toISOString(),
                    );
                  },
                },
              ],
            }}
            style={{ width: "100%" }}
            title={"Open Proposals"}
          />
        </ThemeProvider>
      </div>

      {/* ================= Open Invoices ================= */}
      <div className="dashboard-table-container" style={{ marginTop: "24px" }}>
        <ThemeProvider theme={theme}>
          <MaterialTable
            isLoading={loadingTable}
            columns={openInvoicescolumns}
            className="genericTable"
            components={{
              Toolbar: (props) => (
                <div style={tableToolbarStyle}>
                  <div style={{ flex: "1 1 300px" }}>
                    <MTableToolbar {...props} />
                  </div>
                  <Space wrap align="center" size={12}>
                    <Select
                      allowClear
                      placeholder="Quick Filter"
                      className="filter-select"
                      value={dateFilter}
                      onChange={handleInvoiceDateFilter}
                      options={dateOptions}
                    />
                    <Select
                      allowClear
                      placeholder="Filter by Status"
                      className="filter-select"
                      value={invoiceStatusFilter}
                      onChange={(v) => setInvoiceStatusFilter(v)}
                      options={invoiceStatusOptions}
                    />
                    <RangePicker
                      value={invoiceDateRange || undefined}
                      onChange={handleInvoiceDateRangeChange}
                      format="MM/DD/YYYY"
                      className="filter-range-picker"
                      placeholder={[
                        "From (Date of Service)",
                        "To (Date of Service)",
                      ]}
                      allowClear
                    />
                    <Button
                      className="filter-clear-btn"
                      onClick={() => {
                        setInvoiceStatusFilter(undefined);
                        setInvoiceDateRange(null);
                        setDateFilter(undefined);
                      }}
                    >
                      Clear
                    </Button>
                  </Space>
                </div>
              ),
            }}
            data={filteredOpenInvoicesData}
            actions={[
              (rowData) => ({
                icon: () => (
                  <FileOpenOutlinedIcon className="table-action-icon table-action-icon--documents" />
                ),
                tooltip: "Open Documents",
                onClick: (event, rowData) => {
                  showInvoiceDocumentsList(rowData);
                },
              }),
              (rowData) => ({
                icon: () => (
                  <PaidOutlinedIcon className="table-action-icon table-action-icon--payment" />
                ),
                tooltip: !rowData.invoiceQBOPaymentLink
                  ? "No payment link available"
                  : "Pay this invoice",
                onClick: (event, rowData) => onAskPay(rowData),
                disabled:
                  !rowData.invoiceQBOPaymentLink ||
                  rowData.invoiceStatus?._id !== "JCIS",
              }),
            ]}
            options={{
              actionsColumnIndex: -1,
              pageSize: 5,
              filtering: false,
              exportMenu: [
                {
                  label: "Export to PDF",
                  exportFunc: () => {
                    const rows = buildInvoiceExportRows(
                      filteredOpenInvoicesData,
                    );
                    ExportPdf(
                      invoiceExportColumns,
                      rows,
                      "Invoice Report - " + new Date().toISOString(),
                    );
                  },
                },
                {
                  label: "Export to CSV",
                  exportFunc: () => {
                    const rows = buildInvoiceExportRows(
                      filteredOpenInvoicesData,
                    );
                    ExportCsv(
                      invoiceExportColumns,
                      rows,
                      "Invoice Report - " + new Date().toISOString(),
                    );
                  },
                },
              ],
            }}
            style={{ width: "100%" }}
            title={"Open Invoices"}
          />
        </ThemeProvider>
      </div>

      <Modal
        title={modalTitle}
        open={isVisibleModal}
        setIsVisible={setIsVisibleModal}
        className={
          modalTitle === "Approve this proposal" ||
          modalTitle === "Confirm payment"
            ? null
            : "openModalDocumentsList"
        }
      >
        {modalContent}
      </Modal>
    </>
  );

  // =========================
  // Utils de charts (tus funciones)
  // =========================
  function getParcData(payload) {
    let withOutPARC = 0;
    let withPARC = 0;
    let withDueSoonPARC = 0;

    let dataArray = [];
    let dataRender = [];
    let dataWithOutPARC = [];
    let dataWithPARC = [];
    let dataWithDueSoonPARC = [];

    payload?.mySites?.forEach((site) => {
      if (site.PARCAgreement) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const thirtyDaysAfter = new Date();
        thirtyDaysAfter.setDate(thirtyDaysAfter.getDate() + 30);

        const isWithinRange =
          new Date(site.PARCAgreementEndDate) >= today &&
          new Date(site.PARCAgreementEndDate) <= thirtyDaysAfter;
        const isGreaterThanRange =
          new Date(site.PARCAgreementEndDate) > thirtyDaysAfter;

        if (site.PARCAgreement && isWithinRange) {
          withDueSoonPARC += 1;
          dataWithDueSoonPARC.push(site);
        }
        if (isGreaterThanRange) {
          withPARC += 1;
          dataWithPARC.push(site);
        }
        if (!isWithinRange && !isGreaterThanRange) {
          withOutPARC += 1;
          dataWithOutPARC.push(site);
        }
      } else {
        withOutPARC += 1;
        dataWithOutPARC.push(site);
      }
    });

    const colorsArray = getRandomRGB(3);

    const labelsArr = ["Not PARC"];
    dataArray.push(withOutPARC);
    dataRender.push(dataWithOutPARC);

    if (withPARC > 0) {
      labelsArr.push("PARC");
      dataArray.push(withPARC);
      dataRender.push(dataWithPARC);
    }

    if (withDueSoonPARC > 0) {
      labelsArr.push("PARC due soon");
      dataArray.push(withDueSoonPARC);
      dataRender.push(dataWithDueSoonPARC);
    }

    const data = {
      labels: labelsArr,
      datasets: [
        {
          data: dataArray,
          backgroundColor: colorsArray,
          borderColor: ["#fff"],
          borderWidth: 1,
          dataRender: dataRender,
        },
      ],
    };

    return data;
  }

  function getProposalsByStatusData(payload) {
    let labelsArr = [];
    let valuesArr = [];
    let dataRender = [];

    payload?.proposalByStatusSummary?.forEach(function (status) {
      if (status.value > 0) {
        labelsArr.push(status.key);
        valuesArr.push(status.value);
        dataRender.push(status.data);
      }
    });

    const colorsArray = getRandomRGB(valuesArr.length);
    const data = {
      labels: labelsArr,
      datasets: [
        {
          data: valuesArr,
          backgroundColor: colorsArray,
          borderColor: ["#fff"],
          borderWidth: 1,
          dataRender: dataRender,
        },
      ],
    };

    return data;
  }

  function getInovoicesByStatusData(payload) {
    let labelsArr = [];
    let valuesArr = [];
    let dataRender = [];

    payload?.allInvoicesByStatus?.forEach(function (item) {
      const total = item.invoices.length;
      labelsArr.push(item.status);
      valuesArr.push(total);
      dataRender.push(item.invoices);
    });

    const colorsArray = getRandomRGB(valuesArr.length);
    const data = {
      labels: labelsArr,
      datasets: [
        {
          data: valuesArr,
          backgroundColor: colorsArray,
          borderColor: ["#fff"],
          borderWidth: 1,
          dataRender: dataRender,
        },
      ],
    };

    return data;
  }

  function getRandomRGB(elementsNumber) {
    const premiumPalette = [
      "#E16726", // Brand Orange
      "#2563EB", // Royal Blue
      "#10B981", // Emerald Green
      "#8B5CF6", // Violet Purple
      "#EC4899", // Magenta Pink
      "#F59E0B", // Amber Gold
      "#06B6D4", // Turquoise Cyan
      "#EF4444", // Crimson Red
      "#84CC16", // Lime Green
    ];
    const colors = [];
    for (let i = 0; i < elementsNumber; i++) {
      if (i < premiumPalette.length) {
        colors.push(premiumPalette[i]);
      } else {
        const hue = (i * 137.5) % 360;
        colors.push(`hsl(${hue}, 70%, 60%)`);
      }
    }
    return colors;
  }
}
